import 'react';
import Container from '@lendi-ui/container';
import Grid from '@lendi-ui/grid';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { my } from '@lendi-ui/spacing';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var _templateObject, _templateObject2;
var VideoContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  padding-top: ", "%;\n  ", "\n"])), 9 / 16 * 100, function (_ref) {
  var size = _ref.size;
  return size === 'full' ? my('xxl') : my('lg');
});
var FullWidthVideo = styled.iframe(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: initial;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n"])));

var GenericVideo = function GenericVideo(_ref) {
  var src = _ref.src,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size;
  var sizes = {
    md: {
      xs: 1,
      md: 3 / 4,
      lg: 3 / 5,
      xl: 3 / 4
    },
    lg: {
      xs: 1,
      lg: 4 / 5,
      xl: 5 / 6
    }
  };
  return /*#__PURE__*/jsx(Container, {
    children: /*#__PURE__*/jsx(Grid, {
      halign: "center",
      children: /*#__PURE__*/jsx(Grid.Unit, {
        size: size === 'full' ? 1 : sizes[size],
        children: /*#__PURE__*/jsx(VideoContainer, {
          size: size,
          children: /*#__PURE__*/jsx(FullWidthVideo, {
            src: src
          })
        })
      })
    })
  });
};

export { GenericVideo as default };
